export const LEFT_HAND_NEUTRAL = [
  {
    t: [-0.05, -0.08, -0.1],
    r: [0.53411, 0.018204, -0.222429, 0.815436],
    s: [1, 1, 1],
  },
  {
    t: [-0.027338, -0.067039, -0.122241],
    r: [0.394372, -0.415858, -0.220458, 0.789271],
    s: [1, 1, 1],
  },
  {
    t: [0.017754, -0.043135, -0.143554],
    r: [0.514492, -0.382382, -0.392596, 0.659546],
    s: [1, 1, 1],
  },
  {
    t: [0.043077, -0.032545, -0.149159],
    r: [0.56159, -0.206804, -0.487, 0.636248],
    s: [1, 1, 1],
  },
  {
    t: [0.067278, -0.017229, -0.159647],
    r: [0.56161, -0.206811, -0.487017, 0.636271],
    s: [1, 1, 1],
  },
  {
    t: [-0.032269, -0.059371, -0.115777],
    r: [0.567561, -0.097691, -0.203196, 0.791889],
    s: [1, 1, 1],
  },
  {
    t: [-0.005609, 0.002735, -0.153999],
    r: [0.507186, -0.063324, -0.203911, 0.83502],
    s: [1, 1, 1],
  },
  {
    t: [0.007245, 0.035597, -0.172199],
    r: [0.458663, -0.049313, -0.205676, 0.86312],
    s: [1, 1, 1],
  },
  {
    t: [0.013177, 0.052938, -0.185024],
    r: [0.397899, -0.002456, -0.189554, 0.897684],
    s: [1, 1, 1],
  },
  {
    t: [0.016515, 0.069224, -0.201788],
    r: [0.397916, -0.002456, -0.189562, 0.897722],
    s: [1, 1, 1],
  },
  {
    t: [-0.043623, -0.053662, -0.112719],
    r: [0.553746, -0.007309, -0.191796, 0.810263],
    s: [1, 1, 1],
  },
  {
    t: [-0.028562, 0.010251, -0.145199],
    r: [0.472064, 0.017109, -0.111029, 0.874356],
    s: [1, 1, 1],
  },
  {
    t: [-0.02549, 0.045618, -0.168513],
    r: [0.441765, -0.01643, -0.133573, 0.886956],
    s: [1, 1, 1],
  },
  {
    t: [-0.021146, 0.069622, -0.187059],
    r: [0.310755, -0.005124, -0.143074, 0.939638],
    s: [1, 1, 1],
  },
  {
    t: [-0.019044, 0.083146, -0.207534],
    r: [0.310762, -0.005124, -0.143078, 0.939662],
    s: [1, 1, 1],
  },
  {
    t: [-0.055288, -0.052779, -0.110872],
    r: [0.521068, 0.080546, -0.193884, 0.827277],
    s: [1, 1, 1],
  },
  {
    t: [-0.051159, 0.007143, -0.141754],
    r: [0.461693, 0.031862, -0.045643, 0.885256],
    s: [1, 1, 1],
  },
  {
    t: [-0.051676, 0.039517, -0.165253],
    r: [0.378491, 0.011831, -0.061086, 0.923512],
    s: [1, 1, 1],
  },
  {
    t: [-0.051113, 0.062013, -0.187766],
    r: [0.260819, 0.021358, -0.083438, 0.961583],
    s: [1, 1, 1],
  },
  {
    t: [-0.051187, 0.072388, -0.207475],
    r: [0.260827, 0.021359, -0.083441, 0.961614],
    s: [1, 1, 1],
  },
  {
    t: [-0.066037, -0.054584, -0.108849],
    r: [0.488069, 0.176432, -0.171185, 0.837447],
    s: [1, 1, 1],
  },
  {
    t: [-0.074056, -0.000635, -0.137437],
    r: [0.440891, 0.100924, 0.027575, 0.891356],
    s: [1, 1, 1],
  },
  {
    t: [-0.080655, 0.025614, -0.159345],
    r: [0.437071, 0.097627, 0.021249, 0.893713],
    s: [1, 1, 1],
  },
  {
    t: [-0.085037, 0.043556, -0.172445],
    r: [0.3904, 0.08214, -0.029839, 0.916297],
    s: [1, 1, 1],
  },
  {
    t: [-0.08881, 0.056942, -0.18567],
    r: [0.390393, 0.082139, -0.029838, 0.916279],
    s: [1, 1, 1],
  },
] as const;

export const RIGHT_HAND_NEUTRAL = [
  {
    t: [0.05, -0.08, -0.1],
    r: [0.53411, -0.018204, 0.222429, 0.815436],
    s: [1, 1, 1],
  },
  {
    t: [0.027338, -0.067039, -0.122241],
    r: [0.394372, 0.415858, 0.220458, 0.789271],
    s: [1, 1, 1],
  },
  {
    t: [-0.017754, -0.043135, -0.143554],
    r: [0.514492, 0.382382, 0.392596, 0.659546],
    s: [1, 1, 1],
  },
  {
    t: [-0.043077, -0.032545, -0.149159],
    r: [0.56159, 0.206804, 0.487, 0.636248],
    s: [1, 1, 1],
  },
  {
    t: [-0.067278, -0.017229, -0.159647],
    r: [0.56161, 0.206811, 0.487017, 0.636271],
    s: [1, 1, 1],
  },
  {
    t: [0.032269, -0.059371, -0.115777],
    r: [0.567561, 0.097691, 0.203196, 0.791889],
    s: [1, 1, 1],
  },
  {
    t: [0.005609, 0.002735, -0.153999],
    r: [0.507186, 0.063324, 0.203911, 0.83502],
    s: [1, 1, 1],
  },
  {
    t: [-0.007245, 0.035597, -0.172199],
    r: [0.458663, 0.049313, 0.205676, 0.86312],
    s: [1, 1, 1],
  },
  {
    t: [-0.013177, 0.052938, -0.185024],
    r: [0.397899, 0.002456, 0.189554, 0.897684],
    s: [1, 1, 1],
  },
  {
    t: [-0.016515, 0.069224, -0.201788],
    r: [0.397916, 0.002456, 0.189562, 0.897722],
    s: [1, 1, 1],
  },
  {
    t: [0.043623, -0.053662, -0.112719],
    r: [0.553746, 0.007309, 0.191796, 0.810263],
    s: [1, 1, 1],
  },
  {
    t: [0.028562, 0.010251, -0.145199],
    r: [0.472064, -0.017109, 0.111029, 0.874356],
    s: [1, 1, 1],
  },
  {
    t: [0.02549, 0.045618, -0.168513],
    r: [0.441765, 0.01643, 0.133573, 0.886956],
    s: [1, 1, 1],
  },
  {
    t: [0.021146, 0.069622, -0.187059],
    r: [0.310755, 0.005124, 0.143074, 0.939638],
    s: [1, 1, 1],
  },
  {
    t: [0.019044, 0.083146, -0.207534],
    r: [0.310762, 0.005124, 0.143078, 0.939662],
    s: [1, 1, 1],
  },
  {
    t: [0.055288, -0.052779, -0.110872],
    r: [0.521068, -0.080546, 0.193884, 0.827277],
    s: [1, 1, 1],
  },
  {
    t: [0.051159, 0.007143, -0.141754],
    r: [0.461693, -0.031862, 0.045643, 0.885256],
    s: [1, 1, 1],
  },
  {
    t: [0.051676, 0.039517, -0.165253],
    r: [0.378491, -0.011831, 0.061086, 0.923512],
    s: [1, 1, 1],
  },
  {
    t: [0.051113, 0.062013, -0.187766],
    r: [0.260819, -0.021358, 0.083438, 0.961583],
    s: [1, 1, 1],
  },
  {
    t: [0.051187, 0.072388, -0.207475],
    r: [0.260827, -0.021359, 0.083441, 0.961614],
    s: [1, 1, 1],
  },
  {
    t: [0.066037, -0.054584, -0.108849],
    r: [0.488069, -0.176432, 0.171185, 0.837447],
    s: [1, 1, 1],
  },
  {
    t: [0.074056, -0.000635, -0.137437],
    r: [0.440891, -0.100924, -0.027575, 0.891356],
    s: [1, 1, 1],
  },
  {
    t: [0.080655, 0.025614, -0.159345],
    r: [0.437071, -0.097627, -0.021249, 0.893713],
    s: [1, 1, 1],
  },
  {
    t: [0.085037, 0.043556, -0.172445],
    r: [0.3904, -0.08214, 0.029839, 0.916297],
    s: [1, 1, 1],
  },
  {
    t: [0.08881, 0.056942, -0.18567],
    r: [0.390393, -0.082139, 0.029838, 0.916279],
    s: [1, 1, 1],
  },
] as const;
